import { selectDictionaries } from './selectDictionaries';

export const selectProgramsSummary = (state: Parameters<typeof selectDictionaries>[0]) =>
  selectDictionaries(state).programsSummary;
